/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Split_By_LotInputs */

const vi_sales_return_split_by_lot = /** @type {(inputs: Sales_Return_Split_By_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chia theo lô`)
};

/**

* @param {Sales_Return_Split_By_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_split_by_lot = /** @type {((inputs?: Sales_Return_Split_By_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Split_By_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_split_by_lot(inputs)
});